import { Colors, Fonts, Metrics } from '../../../../Themes/'

export default {
  cardContainer: {
    marginTop: 0,
    marginBottom: Metrics.baseMargin,
    backgroundColor: Colors.cardBackground,
    borderRadius: Metrics.baseMargin,
    borderWidth: Metrics.buttonBorderWidth,
    borderColor: Colors.lighterGray,
    borderStyle: 'solid',
  },
  card: {
    padding: Metrics.baseMarginPlus,
    flexDirection: 'row',
    alignItems: 'flex-start',
    display: 'flex'
  },
  cardRemovePaddingLeft: {
    paddingLeft: 0
  },
  contentContainer: {
    flex: 1,
    flexDirection: 'column',
    display: 'flex'
  },
  contentContainerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    display: 'flex'
  },
  title: {
    color: Colors.darkGray,
    fontWeight: Fonts.weight.bold,
    marginBottom: Metrics.baseMargin
  },
  titleRight: {
    marginBottom: Metrics.baseMargin,
    fontSize: Fonts.size.small,
    textAlign: 'right'
  },
  titleFullWidth: {
    width: '100%'
  },
  lineItem: {
    paddingBottom: Metrics.baseMarginPlus,
    marginBottom: Metrics.baseMarginPlus,
    borderBottomWidth: Metrics.listItemBorderWidth,
    borderBottomStyle: 'solid',
    borderColor: Colors.lightGray,
    flexDirection: 'row',
    alignItems: 'center',
    display: 'flex'
  },
  lineItemLast: {
    marginBottom: 0,
    paddingBottom: 0,
    borderColor: Colors.transparent
  },
  lineItemLeft: {
    flex: 4,
    marginRight: Metrics.baseMargin
  },
  lineItemRight: {
    flex: 2
  },
  lineItemRightImportant: {
    flex: 4
  },
  lineItemText: {
    fontSize: Fonts.size.small
  },
  lineItemLabel: {
    color: Colors.darkGray
  },
  lineItemLabelBold: {
    fontWeight: Fonts.weight.bold,
    color: Colors.darkGray
  },
  lineItemLabelBoldColored: {
    fontWeight: Fonts.weight.bold,
    color: Colors.theme1
  },
  lineItemButton: {
    marginTop: 0,
    marginBottom: 0,
    padding: Metrics.smallMargin
  },
  emptySpaceBig: {
    marginTop: Metrics.baseMarginPlus,
    marginBottom: Metrics.baseMarginPlus
  },
  iconWarningPayPending: {
    position: 'relative',
    top: 0,
    right: 20,
    flexDirection: 'row',
    backgroundColor: Colors.mainBackground,
    display: 'flex'
  }
}